export const ADD_COLOR_SCHEME = 'ADD_COLOR_SCHEME';
export const CHANGE_COLOR = 'CHANGE_COLOR';
export const CHANGE_COLORS = 'CHANGE_COLORS';
export const ADD_COLOR = 'ADD_COLOR';
export const SELECT_PATH = 'SELECT_PATH';
export const SELECT_TILE = 'SELECT_TILE';
export const SELECT_SAMPLE = 'SELECT_SAMPLE';
export const SELECT_COLOR = 'SELECT_COLOR';
export const DEFAULT_COLORS = ' DEFAULT_COLORS';



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js